import { APP_ROUTES, APP_SCOPE } from "../constants/global.constants";

const ADVISOR_BASE_URL = process.env.REACT_APP_URL + "/advisor/api/v1";
const CA_ROUTE_MARKERS = [`/${APP_ROUTES.CLEANING_ADVISOR_HOME.toLowerCase()}`];
const RA_ROUTE_MARKERS = [`/${APP_ROUTES.LIFETIME_ADVISOR_HOME.toLowerCase()}`];

const getPathname = () => {
  if (typeof window === "undefined") {
    return "";
  }

  return window.location?.pathname?.toLowerCase() || "";
};

export const getRouteAppScope = () => {
  const pathname = getPathname();

  if (CA_ROUTE_MARKERS.some((marker) => pathname.includes(marker))) {
    return APP_SCOPE.CA;
  }

  if (RA_ROUTE_MARKERS.some((marker) => pathname.includes(marker))) {
    return APP_SCOPE.RA;
  }

  return APP_SCOPE.BASE;
};

export const getAppBaseURL = (overrideAppScope = APP_SCOPE.AUTO) => {
  const resolvedScope =
    overrideAppScope === APP_SCOPE.AUTO ? getRouteAppScope() : overrideAppScope;

  if (resolvedScope === APP_SCOPE.CA || resolvedScope === APP_SCOPE.RA) {
    return `${ADVISOR_BASE_URL}/${resolvedScope}/`;
  }

  return `${ADVISOR_BASE_URL}/`;
};
